export default "__VITE_ASSET__952c3972__"